import { createSlice } from "@reduxjs/toolkit";
export const MY_TEAM = "myteam"

const myteamSlice = createSlice({
    name: MY_TEAM,
    initialState: {
        isLoading: false,
        timePlanShiftByCompany: [],
        subOrdinatesList: [],
        supervisorDetails: {},
        calendarStartDate: null,
        calendarEndDate: null,
        employeeRequestCalendar: [],
        isHrView: false,
        isLeaveHrView: false,
        isShiftHrView: false,
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setTimePlanShiftByCompany(state, action) {
            state.timePlanShiftByCompany = action.payload;
        },
        setSubOrdinatesList(state, action) {
            state.subOrdinatesList = action.payload
        },
        setSupervisorDetails(state, action) {
            state.supervisorDetails = action.payload
        },
        setCalendarStartDate(state, action) {
            state.calendarStartDate = action.payload
        },
        setCalendarEndDate(state, action) {
            state.calendarEndDate = action.payload
        },
        setEmployeeRequestCalendar(state, action) {
            state.employeeRequestCalendar = action.payload
        },
        setIsHrView: (state, action) => {
            state.isHrView = action.payload;
        },
        setIsLeaveHrView: (state, action) => {
            state.isLeaveHrView = action.payload;
        },
        setIsShiftHrView: (state, action) => {
            state.isShiftHrView = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setTimePlanShiftByCompany,
    setSubOrdinatesList,
    setSupervisorDetails,
    setCalendarStartDate,
    setCalendarEndDate,
    setEmployeeRequestCalendar,
    setIsHrView,
    setIsLeaveHrView,
    setIsShiftHrView
} = myteamSlice.actions;
export default myteamSlice.reducer;
